import { Button, Loading, Title } from "@components";

import { useEffect, useRef, useState } from "react";
import { ReportsAPI } from "providers/ReportsAPI";
import { If } from "shared/components/control-statements";
import Registers from "pages/Reports/Orders/Registers";
import Filters from "pages/Reports/Filters";
import ReportFilters from "pages/Reports/ReportFilters";

export default function Index() {
  const [openFilters, setOpenFilters] = useState(false);
  const [filters, setFilters] = useState({});
  const [dateFilters, setDateFilters] = useState({});

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const filtersRef = useRef(null);

  const fetchData = async () => {
    setLoading(true);
    const provider = new ReportsAPI();
    const response = await provider.orders(filters);
    setData(response);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  return (
    <>
      <Title
        title="Novos cadastros"
        backTo={{ url: "/relatorios/clientes", name: "Clientes" }}
      >
        <Filters
          onRemoveFilter={(filter) => {
            filtersRef.current?.removeFilter(filter);
          }}
          filters={filters}
        />
        <Button onClick={() => setOpenFilters(true)}>Filtrar</Button>
      </Title>

      <If cond={loading}>
        <Loading fullContent />
      </If>

      <Registers data={data?.customers || []} />

      <ReportFilters
        ref={filtersRef}
        open={openFilters}
        filters={filters}
        dateFiltersProp={dateFilters}
        onClose={() => setOpenFilters(false)}
        onUpdateFilters={(filters) => {
          setFilters(filters);
        }}
        hideBrands
        hideOrigins
        onUpdateDateFilters={(filters) => {
          setDateFilters(filters);
        }}
      />
    </>
  );
}
